<template>
    <div class="row mb-0 no-gutters" >
        <div class="col-lg-12">
            <div class="row mb-0" style="margin-top:20px;">
                <div class="py-lg-0 col-md-12">
                    <div class="card cardModuleM h-100">
                        <div class="card-content h-100 d-md-flex align-items-md-center">
                            <div class="row mb-0 no-gutters horizontal-scroll-reports" style="height: 50vh; overflow: hidden;">
                                <div class="col-lg-2 collection listColection">
                                    <a 
                                        v-for="(item, i) in form_system_list" :key="i" 
                                        :class="`collection-item list-colection-item ${category === item.identify ? 'list-colection-item-selected' : ''}`"
                                        :style="`font-weight:bold; text-decoration:none; width: 90%; border-radius: 6px;`"
                                        v-html="item.name"
                                        :href="`#${item.identify}`"
                                        @click="category = item.identify"
                                    />
                                </div>
                                <div class="col-lg-10 horizontal-scroll-reports" style="overflow: hidden;">
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-lg-12">
                                            <div class="table-responsive mt-1 panel-scroll" style="max-height: 50vh">
                                                <table class="table">
                                                    <tbody>
                                                        <template v-if="display_items.length" >
                                                            <tr v-for="(item, i) in display_items" :key="i">

                                                                <td v-for="(header, j) in select_headers" :key="j" scope="col">
                                                                    <template v-if="header.type === 'dropdown_to_fill'">
                                                                        <div class="py-0" v-if="item[header.type] === 'single_option'" id="multiselect__schedule" style="width: 24rem">
                                                                            <multiselect @open="disabledOverflow = true" @close="disabledOverflow = false"  v-model="item.associated_id"  :options="array_options[item.associated_records]" :multiple="false" :close-on-select="false" :clear-on-select="false" track-by="id" :taggable="true" :placeholder="item.placeholder" label="name" :searchable="true"  :preselect-first="false">
                                                                            </multiselect>
                                                                        </div>
                                                                        <div class="py-0" v-if="item[header.type] === 'multiple_options'" id="multiselect__schedule" style="width: 24rem">
                                                                            <multiselect @open="disabledOverflow = true" @close="disabledOverflow = false"  v-if="item[header.type] === 'multiple_options'"  v-model="item.associated_id"  :options="array_options[item.associated_records]" :multiple="true" :value="'Integer'" :close-on-select="false"  :clear-on-select="false" track-by="id" :taggable="true" :placeholder="item.placeholder" label="name" :searchable="true" :preselect-first="false">
                                                                                <template slot="selection" slot-scope="{ values }"><span class="multiselect__single" v-if="values.length" >{{ values.length }} {{item.alias}}{{ values.length > 1  ? 's' : ''}}  selected</span></template>
                                                                            </multiselect>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else-if="header.type === 'link_action'" >
                                                                        <a class="bold-text action-report" @click="actionReport(item.component_href, item.associated_id)">{{ header.static_value }}</a>
                                                                    </template>
                                                                    <template v-else>
                                                                        {{ item[header.value] }}
                                                                    </template>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <InspectionScoreReportModal 
        :breadcrumb="breadcrumb"
        :array_options="array_options"
        />
    </div>
</template>

<script>
import InspectionScoreReportModal from './InspectionScoreReportModal'
import Resources from    './resources'
import ReportResources from '../Reports/resources'
import { Notyf }    from 'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
import Multiselect  from    "vue-multiselect"
const notyf = new Notyf({
    duration: 8000,
});

export default {

    components: {
        Multiselect,
        InspectionScoreReportModal
    },

    props: [
        'margin_left',
        'search'
    ],

    data()
    {
        return{
            select_headers:  Resources.table_headers,
            rest_api: 'standard_reports',
            items: [],
            array_options: {},
            sortable: false,
            notyf,
            disabledOverflow: false,
            breadcrumb: Resources.breadcrumb,
            form_system_list: ReportResources.form_system_list,
            category: 'all'
        }

    },

    methods:
    {

        fill_data(data)
        {
           this.items = data.standard_reports
           this.array_options = 
           {
                daily_assignments: data.daily_assignments,
                staffing_scenarios: data.staffing_scenarios,
                inspection_templates: data.inspection_templates,
                inspection_template_id: data.inspection_templates,
                building_id: data.buildings,
                room_type_id: data.room_types,
                employee_associate_id: data.employee_associates,
                associate_id: data.associates,
                level_id: [],
                area_id: []

           }
        },

        actionReport(url, param_id)
        {
            let new_params = null; 

            switch (url)
            {
                case 'qc_quality_review':
                    this.qcQualityReviewReport(param_id)
                break;
                case 'qc_inspection_score_report':
                    this.showModalInspectionScoreReport(param_id)
                break;
                case '/standard-reports/qc/room-type-summary-by-building':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/completed-inspection-by-supervisor':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/census/productivity-summary':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/census/productivity-summary-by-associate':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/census/productivity-summary-by-assignment':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/inspection-item-score-overall':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/buildings/medicare-time-square-footage-summary':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/completed-inspection':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/projects/project-assignment?supervisor_copy=true':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/projects/project-assignment?supervisor_copy=false':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/projects/project-completion-room':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/assignment-time-square-footage':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/assignment-duties-with-clean-code':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/assignment-info-by-shift':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/assignment-time-utilization':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/over-under-unassigned-rooms':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/options/default-project-task-frequency-report':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/buildings/building-room-usage-report':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/projects/next-scheduled-projects-report':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/assignment-weekly-minutes-report':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/assignment/tasks-step-codes-association':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/supervisor-inspection-completion-report-by-template':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/inspection-template-completion-by-room':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/inspection-rooms-completion-by-area':
                    this.$router.push(`${url}`)
                break;
                case '/standard-reports/qc/inspection-items-grouped-by-template':
                    this.$router.push(`${url}`)
                break;
                default:
                    if(Array.isArray(param_id) && param_id.length)
                    {
                        new_params = []
                        param_id.filter(item => {
                            new_params.push(item.id)
                        })
                        new_params = JSON.stringify(new_params)
                    }
                    else if(param_id && Object.keys(param_id).length)
                    {
                        new_params = param_id.id
                    }
                    else
                    {
                        notyf.error('Select an item')
                        return;
                    }
                        
                    this.$router.push(`${url}/${new_params}`)
            
                }
        },

        async showModalInspectionScoreReport() 
        {
            window.$('#inspection-score-report').modal('show')
        },

        async qcQualityReviewReport(param_id)
        {
            const form_data = {
                standard_report_id: 8,
                format: 'portrait',
                inspection_template_ids: param_id
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if(response.status)
            {
                this.downloadFile(response)
            }
            else
            {
                window.$('#static-supervisor-modal').modal('show')
                this.error_handling(response)
            }

            this.loader()
        },
    },
    computed: {
        display_items()
        {
            let filtered_items = this.items

            if(this.category && this.category !== 'all')
            {
                filtered_items = filtered_items.filter(item => item.module === this.category)
            }
            if(this.search)
            {
                filtered_items = filtered_items.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
            }

            return filtered_items
        }

    },
    async mounted()
    {
        if(this.hasPermissions(['Report Read']) )
        {
            await this.api_request()
        }
    }

}
</script>
